<script>
  import ContactCard from "./ContactCard.svelte";
  export let usersArray = [];
  export let found;
</script>

<style>
  .contacts-list {
    width: 100%;
    height: 100%;
    border: 1px solid #c7c3c3;
    border-radius: 3px;
    padding: 2.5rem;
    overflow-y: scroll;
  }

  .not-yet {
    text-align: center;
    font-size: 1.8rem;
  }
</style>

{#if found}
  <div class="contacts-list">
    {#if !usersArray.length}
      <p class="not-yet">Not users loaded yet</p>
    {:else}
      {#each usersArray as user}
        <ContactCard
          userName={user.name}
          userSurName={user.surname}
          userRegion={user.region}
          userPhone={user.phone}
          userAge={user.age}
          userEmail={user.email}
          userImg={user.photo} />
      {/each}
    {/if}

  </div>

{:else}
  <div class="contacts-list">
    <p class="not-yet">Not users found</p>
  </div>
{/if}
